import { useShallow } from 'zustand/shallow'

import { useStore, getSelectedDomainObjectsSelector } from '@app/store'

const useGetSelectedDomainObjects = (strategyId: string): ReturnType<typeof getSelectedDomainObjectsSelector> =>
  useStore(useShallow((state) => getSelectedDomainObjectsSelector(state, strategyId)))

export default useGetSelectedDomainObjects
